import classNames from 'classnames';
import css from './H5title.module.scss';

export default function H5title({children, cn, isWhite}) {
  return (
    <h5 className={classNames(css.h5, cn, {[css.white]: isWhite})}>{children}</h5>
  );
}